import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-add",
  "use": "svg_i-add-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_i-add\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M16 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z\" fill=\"currentColor\" fill-rule=\"nonzero\" /><path fill=\"#FFF\" d=\"M15 9.857H9.857V15H8.143V9.857H3V8.143h5.143V3h1.714v5.143H15z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol